import * as React from "react";
import styles from "./MCheckbox.module.css";
import { IconCheck, IconMinus } from "@tabler/icons-react";

export interface MCheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type" | "size"> {
  indeterminate?: boolean;
  checkboxBg?: string; // custom background color for checkbox
  size?: "default" | "compact";
}

export const MCheckbox = React.forwardRef<HTMLInputElement, MCheckboxProps>(
  (
    {
      checked,
      indeterminate,
      disabled,
      className,
      checkboxBg,
      size = "default",
      ...props
    },
    ref
  ) => {
    const inputRef = React.useRef<HTMLInputElement>(null);
    React.useEffect(() => {
      if (inputRef.current) {
        inputRef.current.indeterminate = !!indeterminate;
      }
    }, [indeterminate]);
    const sizeClass = size === "compact" ? styles.compact : "";
    return (
      <label
        className={`${styles.mCheckboxLabel} ${sizeClass} ${className || ""}`}
      >
        <input
          ref={(node) => {
            inputRef.current = node;
            if (typeof ref === "function") ref(node);
            else if (ref)
              (ref as React.MutableRefObject<HTMLInputElement | null>).current =
                node;
          }}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          className={styles.mCheckboxInput}
          aria-checked={indeterminate ? "mixed" : checked}
          aria-disabled={disabled}
          {...props}
        />
        <span
          className={`${styles.mCheckboxCustom} ${sizeClass}`}
          style={
            checkboxBg ? { background: checkboxBg, border: "none" } : undefined
          }
        >
          <span className={styles.mCheckbox__icon}>
            {indeterminate ? (
              <IconMinus size={24} stroke={3} />
            ) : checked ? (
              <IconCheck size={24} stroke={3} />
            ) : null}
          </span>
        </span>
      </label>
    );
  }
);

export default MCheckbox;
